<template>
	<div class="popup save_popup upgrade-popup sign-up">

		<a class="close_popup_btn" v-on:click="changePopup('signUp', false)">
			<span class="inch-icon inch-close-icon"></span>
		</a>
		<h2 class="title sm sign-up">Sign up - it's free</h2>

		<div class="signup-description">
			To download your image, create a free account.
		</div>
		<div class="social-login">
			<button type="submit" @click="socialAuthenticate('google')" class="gsi-material-button">
				<div class="gsi-material-button-state"></div>
				<div class="gsi-material-button-content-wrapper">
					<div class="gsi-material-button-icon">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
							xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
							<path fill="#EA4335"
								d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z">
							</path>
							<path fill="#4285F4"
								d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z">
							</path>
							<path fill="#FBBC05"
								d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z">
							</path>
							<path fill="#34A853"
								d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z">
							</path>
							<path fill="none" d="M0 0h48v48H0z"></path>
						</svg>
					</div>
					<span class="gsi-material-button-contents">Continue with Google</span>
				</div>
			</button>
		</div>

		<div style="display: flex; align-items: center; margin: 1.5rem 0;">
			<div style="flex: 1; height: 1px; background-color: #ccc;"></div>
			<span style="margin: 0 1rem; color: #777; font-weight: 500; font-size: 14px;">
				OR
			</span>
			<div style="flex: 1; height: 1px; background-color: #ccc;"></div>
		</div>

		<form id="login_form" v-on:submit.prevent="onSubmit" v-if="isOnline">
			<div class="form_loading" v-if="isLoading"></div>

			<div class="form-group sign-up">
				<input type="email" ref="xemail" placeholder="Email address" name="email"
					class="form-control xemail sign-up" :value="email" />
			</div>
			<div class="form-group sign-up">
				<input type="password" ref="xpassword" placeholder="Password" name="password"
					class="form-control sign-up" :value="password" />
			</div>
			<div class="form-group sign-up">
				<input type="text" ref="xname" placeholder="Full name" name="full_name" class="form-control sign-up"
					:value="name" />
			</div>
			<div class="form_errors" v-if="formErrors">
				<ul id="example-1">
					<li v-for="(item, index) in formErrors" :key="index">{{ item[0] }}</li>
				</ul>
			</div>

			<div class="btn-wrap sign-up" style="">
				<input type="submit" value="Sign Up" class="btn-orange" style="padding: 15px 40px; width: 100%" />
			</div>

			<div class="bottom-info sign-up">
				<span>Already a member? </span>
				<a @click="showLoginPopUp" style="margin: 0;text-transform:none;opacity:1">Sign in</a>
			</div>
		</form>
	</div>
</template>


<script>
import Acc from "@/libs/acc.js";
import Offline from "@/components/Offline.vue";
const analitics = require("../libs/analytics");
import { Providers } from 'universal-social-auth'

//client@mail.com
//123123123

export default {
	name: "SignUp",
	data() {
		return {
			isLoading: false,
			acc: new Acc(),
			formErrors: null,
			email: "",
			password: "",
			name: ""
		};
	},
	components: {
		Offline
	},
	methods: {
		socialAuthenticate(provider) {
			const ProData = Providers[provider]
			this.$Oauth.authenticate(provider, ProData).then(async (response) => {
				const rsp = response
				if (rsp.code) {
					try {
						const pdata = { code: rsp.code }
						const result = await this.acc.socialLogin(provider, pdata);
						if (result) {
							this.$store.dispatch('refreshUser');
							this.changePopup('signUp', false)
						}
					} catch (error) {
						//
					}
				}
			}).catch((err) => {
				console.log(err)
			})
		},
		async onSubmit(ev) {
			this.isLoading = true;
			this.formErrors = null;
			var resp = await this.acc.register({
				email: this.$refs.xemail.value,
				password: this.$refs.xpassword.value,
				name: this.$refs.xname.value,
			});
			console.log("after register");

			this.formErrors = resp.errors;
			this.isLoading = false;

			if (resp.success) {
				console.log("resp.success", resp.success);
				analitics.sendCustomEvent("sign_up");
				this.$store.state.USER = resp.data.user;
				if (resp.data.user) {
					window.sendinblue.track('signup', { singupType: 'free' });
					window.sendinblue.identify(resp.data.user.email, { 'FIRSTNAME': resp.data.user.name, 'STATUS': resp.data.user.status });
					$('meta[name=uniq_id]').attr('content', resp.data.user.id);
				}

				this.changePopup("signUp", false);
			}
		},
		changePopup(property, value) {
			this.$store.dispatch("popupsToggle", { property, value });
		},
		showLoginPopUp() {
			this.closeAllPopups();
			this.$store.dispatch("popupsToggle", {
				property: "signIn",
				value: true,
			});
		},
		closeAllPopups() {
			this.$store.dispatch("popupsToggle", {
				property: "signUp",
				value: false,
			});
		},
	},
};
</script>

<style scoped>
.gsi-material-button {
	background-color: #f2f2f2;
	background-image: none;
	border: none;
	-webkit-border-radius: 4px;
	border-radius: 4px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	color: #1f1f1f;
	cursor: pointer;
	font-size: 16px;
	height: 40px;
	letter-spacing: 0.25px;
	outline: none;
	overflow: hidden;
	padding: 0 12px;
	position: relative;
	text-align: center;
	-webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
	transition: background-color .218s, border-color .218s, box-shadow .218s;
	vertical-align: middle;
	white-space: nowrap;
	width: auto;
	max-width: 400px;
	min-width: min-content;
	box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25);
}

.gsi-material-button .gsi-material-button-icon {
	height: 20px;
	margin-right: 12px;
	min-width: 20px;
	width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
	-webkit-align-items: center;
	align-items: center;
	display: flex;
	-webkit-flex-direction: row;
	flex-direction: row;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	height: 100%;
	justify-content: space-between;
	position: relative;
	width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
	-webkit-flex-grow: 1;
	flex-grow: 1;
	font-family: 'Roboto', arial, sans-serif;
	font-weight: 500;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
	-webkit-transition: opacity .218s;
	transition: opacity .218s;
	bottom: 0;
	left: 0;
	opacity: 0;
	position: absolute;
	right: 0;
	top: 0;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
	background-color: #001d35;
	opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
	-webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
	box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
	background-color: #001d35;
	opacity: 8%;
}

.form_loading {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #8080809c;
	z-index: 10000;
}

.btn-orange {
	border: none;
}

.form_errors {
	/*color: red;*/
	/*font-weight: bold;*/
	text-align: left;
	font: normal normal normal 14px/34px Soleil;
	color: #FF5353;
}

.popup.save_popup.upgrade-popup.sign-up {
	padding: 52px 38px 37px !important;
	max-width: 420px;
}

.popup.save_popup.upgrade-popup .btn-wrap.sign-up {
	margin-top: 25px !important;
}

.popup.save_popup.upgrade-popup.sign-up .title {
	font-size: 26px;
}

.form-group .label {
	font-size: 13px !important;
}

.popup.save_popup.upgrade-popup .btn-wrap a {
	margin-bottom: 12px;
	display: inline-block;
	text-transform: uppercase;
	/*color: #1d1d1d;*/
	font: normal normal normal 14px/18px Soleil;
	letter-spacing: -0.28px;
	color: #FFFFFF;
}

.popup.save_popup.upgrade-popup .bottom-info.sign-up {
	display: inline-block !important;
	text-align: left;
	font: normal normal normal 14px/18px Soleil;
	letter-spacing: -0.28px;
	color: #000000;

}

.popup.save_popup.upgrade-popup .bottom-info.sign-up {
	margin-top: 16px;

}

.popup.save_popup.upgrade-popup .bottom-info.sign-up span {
	opacity: 0.4;
}

.popup.save_popup.upgrade-popup .bottom-info.sign-up a {
	/*margin-bottom: 12px;*/
	display: inline-block;
	text-transform: none;
	color: #FA6400 !important;
	text-align: left;
	text-decoration: underline;
	letter-spacing: -0.28px;
	margin: 0;
}

.signup-description {
	text-align: center;
	font: normal normal normal 16px/24px Soleil;
	letter-spacing: -0.32px;
	color: #000000;
	opacity: 0.4;
	padding: 16px 5px 20px;
}
</style>
